export const tooltip = (el, setOptions = {}) => {
    const defaultOptions = { position: "none" };
    const dataOptions = el?.dataset?.tooltip
        ? JSON.parse(el?.dataset?.tooltip)
        : {};

    const options = {
        ...defaultOptions,
        ...dataOptions,
        ...setOptions,
    };

    const rectTrigger = el.getBoundingClientRect();
    const refCenter = rectTrigger.width / 2;

    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip", options.position);
    tooltip.innerHTML = el.dataset.title;
    el.append(tooltip);

    const arrow = document.createElement("div");
    arrow.classList.add("arrow");
    tooltip.append(arrow);

    el.addEventListener("mouseenter", (e) => {
        showTooltip();
        e.preventDefault();
        e.stopPropagation();
    });

    el.addEventListener("click", (e) => {
        toggleTooltip();
        e.preventDefault();
        e.stopPropagation();
    });

    document.body.addEventListener("click", (e) => {
        if (tooltip.classList.contains("visable")) {
            hideTooltip();
            e.preventDefault();
            e.stopPropagation();
        }
    });

    function toggleTooltip() {
        if (tooltip.classList.contains("visable")) {
            hideTooltip();
        } else {
            showTooltip();
        }
    }

    function showTooltip() {
        tooltip.style.marginLeft = "auto";
        arrow.style.marginLeft = "auto";
        tooltip.classList.add("visable");

        const rect = tooltip.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
            diff = rect.right - window.innerWidth + 30;
            tooltip.style.marginLeft = `-${diff}px`;
            arrow.style.marginLeft = `${diff + refCenter}px`;
        } else {
            if (options.position == "center") {
                tooltip.style.marginLeft = `${refCenter}px`;
            }
        }
    }

    function hideTooltip() {
        tooltip.classList.remove("visable");
    }

    // mouse leave remove tooltip
    el.addEventListener("mouseleave", () => {
        tooltip.classList.remove("visable");
    });
};
